<template>
  <kst-page-edit autoValidate
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details
      :recPayData="recPayData"
      :userData="userData"
    />
    <RecPay :recPayData="recPayData"/>
  </kst-page-edit>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../RcpyModel.js";
import Services from "../../../services/Api/RecPayServices.js";

import RecPay from "./RcpyES_RecPay.vue";
import Details from "./RcpyES_Details.vue";

export default {
  mixins: [InputPageMixin],
  components: {
    RecPay,
    Details
  },
  data: () => ({
    recPayData: {},
    userData: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadEdit) {
      this.resetData();

      const config = Services.getEditStatusData(id);
      loadEdit(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.recPayData = data.Details;
      Model.setDetailsByStatus(this.recPayData);

      Model.EditStatus.setDetailsByEditData(this.userData, this.recPayData);
      Model.setDetailsByStatus(this.userData);
    },

    handleSubmit(saveData) {
      let data = Model.EditStatus.populateData(this.userData);
      const config = Services.putStatus(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.recPayData = {};
      this.userData = Model.createDetails();
    }
  }
}
</script>